import React, { FC, useCallback, useEffect } from 'react'
import Table from 'uiKit/table/Table'
import * as Styles from './styles'
import { ModalImportAndExportButtonContainer } from './styles'
import Heading from 'uiKit/texts/Heading'
import { useUnknownQuestions } from './context'
import { unansweredQuestionsTableTitles } from './configs'
import { UnknownQuestionTableRow } from './tableRow'
import { UnknownQuestionCreateModal } from './createQuestionModal'
import Pagination from 'uiKit/table/pagination/Pagination'
import { paginationConfigs } from 'tabs/nlp/constants/paginationSize'
import { TrainSearchInput } from '../searchField'
import { mergeTitlesWithSortingMap } from 'uiKit/table/config'
import { FilterPopover } from './filterPopover/FilterPopover'
import { QuestionTypeButtonGroup } from './questionType'
import { TrainButtonState } from './util/button'
import { ExportQuestionsModal } from './exportQuestionModal'
import { ImportQuestionsModal } from './importQuestionModal'

export const UnansweredQuestions: FC = () => {
  const {
    questions,
    setPage,
    page,
    count,
    search,
    areRecordsInitialized,
    updateSearchValue,
    sortHeadersMap,
    isSortingActive,
    dropSortParams,
    loadQueryParamsInSorting,
    questionTypes,
  } = useUnknownQuestions()

  const onPaginationChange = (_, page) => {
    setPage(page)
  }

  const resetSortParams = () => {
    dropSortParams()
  }

  const unQuestionTableTitlesWithSortingMap = useCallback(() => {
    return mergeTitlesWithSortingMap(sortHeadersMap, unansweredQuestionsTableTitles)
  }, [sortHeadersMap, unansweredQuestionsTableTitles])

  useEffect(() => {
    loadQueryParamsInSorting()
  }, [])

  return (
    <Styles.Container>
      <Heading>
        Questions
        <ModalImportAndExportButtonContainer>
          <ExportQuestionsModal />
          <ImportQuestionsModal questionTypes={questionTypes} />
        </ModalImportAndExportButtonContainer>
      </Heading>
      <Styles.SubHeader>Train questions unanswered by the bot</Styles.SubHeader>
      <QuestionTypeButtonGroup questionTypes={questionTypes} />
      <Styles.FiltersContainer>
        <TrainSearchInput placeholder="Search unknown questions" value={search} updateSearchValue={updateSearchValue} />
        <FilterPopover />
        <Styles.ModalButton
          onClick={resetSortParams}
          state={isSortingActive ? TrainButtonState.ACTIVE : TrainButtonState.INACTIVE}>
          Reset Sort Parameters
        </Styles.ModalButton>
        <UnknownQuestionCreateModal questionTypes={questionTypes} />
      </Styles.FiltersContainer>

      <Table titles={unQuestionTableTitlesWithSortingMap()}>
        {questions.map((question, index) => (
          <UnknownQuestionTableRow questionTypes={questionTypes} key={question.id} {...{ question, index }} />
        ))}
      </Table>

      {areRecordsInitialized && (
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <Pagination
            page={page}
            rowsPerPage={paginationConfigs.limit}
            count={count}
            onChangePage={onPaginationChange}
          />
        </div>
      )}
    </Styles.Container>
  )
}
